import React from  'react';
import WordPress from './WordPress';
import ModernWeb from './ModernWeb';
import Legacy from './Legacy';
import Multimedia from './Multimedia';

export let data = [
    {
        name: 'Modern Web',
        text: <ModernWeb />
    },
    {
        name: 'WordPress',
        text: <WordPress />
    },
    {
        name: 'Vanilla/Legacy',
        text: <Legacy />
    },
    {
        name: 'Multimedia',
        text: <Multimedia />
    }    
  ];